import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'SuspendedUsers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo(this.pageNo);
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            StatusFilter: 1, // Fixed: Active suspensions only

            ScreenTitle: 'المستخدمين الموقوفين',
            ScreenTitleSingle: 'مستخدم موقوف',
            ScreenTitleSingleAl: 'المستخدم الموقوف',

            Info: [],
            Statistics: {},
            SelectedItem: null
        };
    },

    methods: {


        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();

            this.$http.GetSuspendedUsers(this.pageNo, this.pageSize, this.Search, this.StatusFilter)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    console.log('Suspended Users Response:', response.data);
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    // Handle both lowercase and uppercase property names
                    this.Statistics = response.data.statistics || response.data.Statistics || {};
                })
                .catch((err) => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    console.error('Error fetching suspended users:', err);
                    this.pages = 0;
                });
        },

        CancelSuspend(Id) {
            Swal.fire({
                title: 'هل أنت متأكد؟',
                text: "سيتم إلغاء تعليق حساب هذا المستخدم",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'نعم، قم بإلغاء التعليق',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.CancelSuspendUser(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },

        getStatusText(status) {
            return status === 1 ? 'نشط' : 'غير نشط';
        },

        getStatusClass(status) {
            return status === 1 ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger';
        },

        onPageSizeChanged(newSize) {
            this.pageSize = newSize;
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        }
    }
};